import type { Static } from 'runtypes';
import { Literal, Record, String, Number } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { ClickstreamEventEnum } from 'bc-model';

const AiShorthandAbandonedEventBrowserRuntype = BaseEventRuntype.And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_SHORTHAND_ABANDONED),
    nodeId: Number,
    originalText: String,
    version: Literal(1),
  })
);

const AiShorthandAbandonedEventServerRuntype = AiShorthandAbandonedEventBrowserRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String,
  })
);

type AiShorthandAbandonedBrowserEvent = Static<typeof AiShorthandAbandonedEventBrowserRuntype>;
type AiShorthandAbandonedServerEvent = Static<typeof AiShorthandAbandonedEventServerRuntype>;

const isAiShorthandAbandonedBrowserEvent = (
  obj: BaseEvent
): obj is AiShorthandAbandonedBrowserEvent => {
  return obj.event === 'AI Shorthand Abandoned';
};

const isAiShorthandAbandonedServerEvent = (
  obj: BaseEvent
): obj is AiShorthandAbandonedServerEvent => {
  return obj.event === 'AI Shorthand Abandoned';
};

export {
  isAiShorthandAbandonedBrowserEvent,
  isAiShorthandAbandonedServerEvent,
  AiShorthandAbandonedEventBrowserRuntype,
  AiShorthandAbandonedEventServerRuntype,
  type AiShorthandAbandonedBrowserEvent,
  type AiShorthandAbandonedServerEvent,
};
